<template>
	<h1
		class="element element--headline element--headline--big"
		:element-translation="i18n ? elementTranslation.found : elementTranslation.missing"
	>
		{{ i18n ? $t(`${content}`) : content }}
	</h1>
</template>

<script>
import { elementTranslation } from '../../tools/consts';
export default {
	props: {
		content: String,
		i18n: Boolean,
	},
	created() {
		this.elementTranslation = elementTranslation;
	},
};
</script>

<style lang="scss">
/****/
</style>
